"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ButtonIcon = _interopRequireDefault(require("@commerce-ui/core2/ButtonIcon"));
var _Spinner = _interopRequireDefault(require("@commerce-ui/core2/Spinner"));
var _core = require("@commerce-ui/core2");
var __jsx = _react["default"].createElement;
var _default = (0, _core.createComponent)(_ButtonIcon["default"], function (_ref) {
  var _ref$$color = _ref.$color,
    $color = _ref$$color === void 0 ? "main" : _ref$$color;
  return {
    height: "44px",
    width: "44px",
    ":focus": {
      outline: 0,
      boxShadow: "none"
    },
    "::-moz-focus-inner": {
      border: 0
    },
    $body: function $body(_ref2) {
      var disabled = _ref2.disabled;
      return {
        color: disabled ? "neutral700" : $color
      };
    },
    $loader: {
      __children: __jsx(_Spinner["default"], {
        sx: {
          $color: $color,
          $color2: "rgba(255,255,255,0.2)"
        }
      })
    }
  };
});
exports["default"] = _default;